export default "__VITE_ASSET__GBL234Lt__"